import { SelectedSIFCompliance } from "./SelectedSIFCompliance";
export default SelectedSIFCompliance;
